import React, { useState } from "react";
import { Authenticator, Sidebar, Input, Button } from "components";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import {
  ErrorScreen,
  NotFoundScreen,
  // LoginScreen,
  NewLoginScreen as LoginScreen,
  LogoutScreen,
  FaqScreen,
  PrivacyPolicy,
  DashboardScreen,
  Settings
} from "screens";
import { isEmbedded } from "lib/wrappers";
import styles from "styles/page.module.scss";
import useReactRouter from "use-react-router";

function App () {
  return (
    <BrowserRouter>
      <ErrorScreen>
        <Routes />
      </ErrorScreen>
    </BrowserRouter>
  );
}

export default App;

const Routes = () => {
  const [newPlanRedirect, setNewPlanRedirect] = useState(null);

  const { location } = useReactRouter();
  const [collapsed, setCollapsed] = useState(false);

  if (
    ["/login", "/auth/shopify/callback"].includes(location.pathname) 
  )
    return (
      <Switch>
        <Route path="/login" component={LoginScreen} />
      </Switch>
    );
    else 
    return (
      <Authenticator>
        <>
          <div className={styles.app_wrapper} data-collapsed={collapsed}>
            <Sidebar />
            <Switch>
              <Route path="/logout" component={LogoutScreen} />

              <Route
                path={["/","/dashboard"]}
                component={isEmbedded({
                  ChildComponent: DashboardScreen,
                  previewOpenByDefault: false,
                  newPlanRedirect
                })}
                exact={true}
              />
              
              <Route
                path="/settings"
                component={isEmbedded({
                  ChildComponent: Settings,
                  previewOpenByDefault: false,
                  newPlanRedirect
                })}
                exact={true}
              />
             
              <Route
                path="/faq"
                component={isEmbedded({
                  ChildComponent: FaqScreen,
                  previewOpenByDefault: false,
                  newPlanRedirect
                })}
              />
              <Route
                path="/privacy_policy"
                component={isEmbedded({
                  ChildComponent: PrivacyPolicy,
                  previewOpenByDefault: false,
                  newPlanRedirect
                })}
              />

              <Route component={NotFoundScreen} />
            </Switch>
          </div>
        </>
      </Authenticator>
    );
};
